exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".image-box {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.image-box img {\n  width: 100%;\n  vertical-align: middle;\n  font-size: 0px;\n}\n", ""]);

// exports
